import React from 'react';
import { Card, CardBody, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import moment from 'moment';
import EOITypes from '@components/EvidenceOfInsurance/Types/Types';
import Attachments from './Attachments';
export default props => {
  const type = EOITypes.find(type => type.key === props.entity.type);
  return (
    <Card className={'h-100'}>
      <CardBody>
        <div className={'font-md color-blue'}>
          <span className={'text-capitalize'}>General Information</span>
        </div>

        <div className={'pt-2 content'}>
          <div className={'pb-3 row'}>
            <div className={'col-6 pb-3'}>
              <strong>Source</strong>
              <br />
              <span>
                {props.entity.evidence_of_insurance_form !== null
                  ? `Cognito Forms`
                  : 'Rapid EOI'}
              </span>
            </div>

            <div className={'col-6 pb-3'}>
              <strong>Reference Number</strong>
              <br />
              {props.entity.evidence_of_insurance_form !== null &&
                `${props.entity.evidence_of_insurance_form.external_id}`}
            </div>
            <div className={'col'}>
              <strong>Issue Date</strong>&nbsp;
              <button onClick={props.onClick}>Edit</button>
              <br />
              {props.issueDate}
            </div>
            <div className={'col'}>
              <strong>EOI Type</strong>&nbsp;
              <button onClick={props.onTypeClick}>Edit</button>
              <br />
              <span>{type !== undefined ? type.label : 'Unknown'}</span>
            </div>
          </div>
          <div className={'pb-3 row'}>
            <div className={'col'}>
              <strong>Effective & Expiration Date</strong>&nbsp;
              <button onClick={props.onClickEffectiveDate}>Edit</button>
              <br />
              {props.entity.effective_date !== null && (
                <React.Fragment>
                  {moment(props.entity.effective_date * 1000).format(
                    'MM/DD/YYYY'
                  )}
                </React.Fragment>
              )}
              {props.entity.expiration_date !== null && (
                <React.Fragment>
                  &nbsp;-&nbsp;
                  {moment(props.entity.expiration_date * 1000).format(
                    'MM/DD/YYYY'
                  )}
                </React.Fragment>
              )}
              {props.entity.set_effective_date === 0 && (
                <span>"See Below" on EOI Document</span>
              )}
            </div>
            <div className={'col d-none'}>
              <strong>Expiration Date</strong>&nbsp;
              <button onClick={props.onClickExpirationDate}>Edit</button>
              <br />
              {props.entity.set_expiration_date === 0 ||
              props.entity.expiration_date === null ? (
                <span>&nbsp;</span>
              ) : (
                moment(props.entity.expiration_date * 1000).format('MM/DD/YYYY')
              )}
            </div>
          </div>
          <Row>
            <Col>
              <div>
                <strong>Include</strong>
              </div>
              <FormGroup check className={'pl-0'}>
                <FormGroup check className={'pb-1 pt-2'}>
                  <Label check>
                    <Input
                      style={{ top: '5px' }}
                      type="checkbox"
                      checked={props.entity.include_cover_letter === 1}
                      disabled={
                        props.entity.tenant.cover_letter === null &&
                        props.entity.association !== null &&
                        props.entity.association.cover_letter === null
                      }
                      onChange={e =>
                        props.saveEntity({
                          include_cover_letter: e.currentTarget.checked ? 1 : 0
                        })
                      }
                    />{' '}
                    Condo Questionnaire
                  </Label>
                </FormGroup>
              </FormGroup>
              <FormGroup check className={'pl-0'}>
                <FormGroup check className={'pb-1 pt-2'}>
                  <Label check>
                    <Input
                      style={{ top: '5px' }}
                      type="checkbox"
                      checked={props.entity.include_sample_quote === 1}
                      disabled={
                        props.entity.association === null ||
                        (props.entity.association.sample_quote === null &&
                          props.entity.association.sample_quote_region_id ===
                            null)
                      }
                      onChange={e =>
                        props.saveEntity({
                          include_sample_quote: e.currentTarget.checked ? 1 : 0
                        })
                      }
                    />{' '}
                    Sample Quote
                  </Label>
                </FormGroup>
              </FormGroup>
            </Col>
            {props.entity.evidence_of_insurance_form !== null && (
              <Col>
                <strong>Additional Information</strong>&nbsp;
                <br />
                <span>
                  {
                    props.entity.evidence_of_insurance_form
                      .additional_information
                  }
                </span>
              </Col>
            )}
            <Col xs={12}>
              <Attachments
                entityId={props.entity.id}
                isMasterCert={props.entity.master_cert_only === 1}
                getEntity={props.getEntity}
              />
            </Col>
          </Row>
          {props.entity.evidence_of_insurance_form !== null && (
            <Row className={'pt-2'}>
              <Col>
                <strong>All Cash Deal</strong>&nbsp;
                <br />
                {props.entity.evidence_of_insurance_form.all_cash_deal === 1
                  ? 'Yes'
                  : 'No'}
              </Col>
              <Col>
                <strong>New Construction</strong>&nbsp;
                <br />
                {props.entity.evidence_of_insurance_form.new_construction === 1
                  ? 'Yes'
                  : 'No'}
              </Col>
            </Row>
          )}
        </div>
      </CardBody>
    </Card>
  );
};
